import { I18n } from 'i18n-js';
import translations from '@/i18n/translations.json';

const i18n = new I18n(translations);

// Returns the CLDR plural category for Russian/Estonian-style pluralization:
// 'zero' | 'one' | 'few' | 'many'. Covers every non-negative integer.
export function pluralize(count) {
  if (count === 0) { return 'zero'; }

  const mod10 = count % 10;
  const mod100 = count % 100;

  if (mod10 === 1 && mod100 !== 11) { return 'one'; }
  if ([2, 3, 4].includes(mod10) && ![12, 13, 14].includes(mod100)) { return 'few'; }
  return 'many';
}

const i18nPluralize = (_i18n, count) => {
  const key = pluralize(count);
  return key === 'zero' ? 'zero' : [key];
};
i18n.pluralization.register('ru', i18nPluralize);
i18n.pluralization.register('et', i18nPluralize);

export const t = i18n.t.bind(i18n);
export const prepared = key =>
  (key2, options) => (
    t(`${key}.${key2}`, options)
  )
;
export default i18n;
